/* eslint-disable jira/filename-case */
import type { Boards } from '../../model/index.tsx';

export const createRapidBoardUrl = (id: string): string =>
	`/secure/RapidBoard.jspa?rapidView=${id}&useStoredSettings=true`;

export const transformResponse = (response: { values: [] }): Boards => {
	const boards = (response && response.values) || [];
	return boards.map((board) => {
		const { name, id } = board;
		const href = createRapidBoardUrl(id);

		return {
			name,
			id,
			href,
		};
	});
};
